import React from "react";

const ventures = [
  {
    name: "Venthan Consultancy Services",
    description: "Providing cutting-edge IT and SaaS solutions.",
    icon: "/assets/icons/venthancs.png",
    link: "https://venthancs.com",
  },
  {
    name: "Info Bulletin",
    description: "A comprehensive platform for blogs and community discussions.",
    icon: "/assets/icons/InfoBulletin.png",
    link: "https://infobulletins.com",
  },
  {
    name: "Chivonix Tech",
    description: "Empowering businesses through technology and innovation.",
    icon: "/assets/icons/Chivonix.png",
    link: "https://chivonixtech.com",
  },
  {
    name: "Trenzy",
    description: "Delivering quality fashion across India.",
    icon: "/assets/icons/Trenzey.png",
    link: "https://trenzy.in",
  },
];

function VenturesSection() {
  return (
    <section id="ventures-section" className="py-16 bg-gray-50">
      <div className="max-w-7xl mx-auto px-6">
        <h2 className="text-4xl font-extrabold text-primary text-center mb-8">
          Our Ventures
        </h2>
        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-8">
          {ventures.map((venture, index) => (
            <div
              key={index}
              className="p-8 bg-white rounded-lg shadow-md hover:shadow-lg transform hover:scale-105 transition"
            >
              <div className="flex items-center justify-center mb-6">
                <img
                  src={venture.icon}
                  alt={`${venture.name} Icon`}
                  className="w-32 h-32"
                />
              </div>
              <h3 className="text-xl font-semibold text-gray-800 text-center mb-2">
                {venture.name}
              </h3>
              <p className="text-gray-600 text-center mb-4">{venture.description}</p>
              <div className="text-center">
                <a
                  href={venture.link}
                  target="_blank"
                  rel="noopener noreferrer"
                  className="bg-primary text-white py-2 px-4 rounded-lg hover:bg-secondary transition"
                >
                  Visit Website
                </a>
              </div>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}

export default VenturesSection;
